// Mock data for metaxuone.com (Celonis clone)

export const navigation = {
  platform: {
    title: 'Platform',
    sections: [
      {
        heading: 'The Platform',
        items: [
          { label: 'Overview', description: 'Discover the MetaxuOne platform', href: '/platform' },
          { label: 'Observability', description: 'End-to-end visibility, in real time', href: '/platform/observability' },
          { label: 'Self Healing', description: 'Resilience that runs itself', href: '/platform/self-healing' },
          { label: 'AI & Agents', description: 'Build, deploy, and orchestrate agents', href: '/platform/ai-agents' },
        ],
      },
      {
        heading: 'Industry Use Case',
        items: [
          { label: 'BFSI',          description: 'Banking, financial services & insurance',  href: '/industries/bfsi' },
          { label: 'Enterprise',    description: 'Large multi-domain enterprises',           href: '/industries/enterprise' },
          { label: 'Pharma',        description: 'GxP-aware regulated operations',           href: '/industries/pharma' },
          { label: 'Manufacturing', description: 'Shop-floor to top-floor visibility',       href: '/industries/manufacturing' },
          { label: 'Government',    description: 'Sovereign, audit-ready public sector',     href: '/industries/government' },
        ],
      },
    ],
  },
  solutions: {
    title: 'Solutions',
    sections: [
      {
        heading: 'Infrastructure',
        items: [
          { label: 'Networking & NW Security',          description: 'Router · Switch · NGFW · Proxy',                  href: '/solutions/networking' },
          { label: 'DC Compute, Storage & Backup',      description: 'Server · Storage · Backup · Virtualization',      href: '/solutions/datacenter' },
          { label: 'Disaster Recovery & Resilience',    description: 'BCDR · operational resilience programs',          href: '/solutions/resilience' },
          { label: 'Public Cloud',                       description: 'Yotta · AWS · Azure · Google Cloud',              href: '/solutions/public-cloud' },
        ],
      },
      {
        heading: 'Security & Governance',
        items: [
          { label: 'Cybersecurity',                      description: 'Email · EDR/NDR/XDR/MDR · DLP · DSPM · CSPM · DNS · SIEM · SOAR', href: '/solutions/cybersecurity' },
          { label: 'IAM & PAM',                          description: 'Identity & privileged access management',         href: '/solutions/iam-pam' },
          { label: 'Patch & Vulnerability Management',  description: 'Scan · prioritize · patch · report',              href: '/solutions/patch-vuln' },
          { label: 'One GRC',                            description: 'ISO · GDPR · DPDP',                               href: '/solutions/grc' },
        ],
      },
      {
        heading: 'Operations & Intelligence',
        items: [
          { label: 'ITSM & ITOM',                        description: 'IT service & operations management',              href: '/solutions/itsm-itom' },
          { label: 'Enterprise Observability',           description: 'NMS · NPM · NPMD · APM · DB Monitoring · Log Analytics', href: '/solutions/observability' },
          { label: 'AI Factory',                         description: 'AI · ML · AIOps · Agentic AI · AI Models',        href: '/solutions/ai-factory' },
          { label: 'NOC & SOC',                          description: 'Network & Security Operations Centers',           href: '/solutions/noc-soc' },
        ],
      },
    ],
  },
  services: {
    title: 'Services',
    sections: [
      {
        heading: 'Plan & Build',
        items: [
          { label: 'Consultancy',    description: 'Advisory, strategy & architecture', href: '/services/consult' },
          { label: 'Assessment',     description: 'Audits, maturity & compliance reviews', href: '/services/assess' },
          { label: 'Implementation', description: 'Systems integration & platform engineering', href: '/services/implement' },
          { label: 'Operation',      description: 'Managed services, ITSM & ITOM', href: '/services/operate' },
        ],
      },
      {
        heading: 'Secure & Evolve',
        items: [
          { label: 'Governance',     description: 'Cybersecurity, risk & GRC', href: '/services/govern' },
          { label: 'Automation',     description: 'Self-healing & autonomous remediation', href: '/services/automate' },
          { label: 'Optimization',   description: 'AIOps & continuous improvement', href: '/services/optimize' },
          { label: 'Transformation', description: 'AI & agentic transformation programs', href: '/services/transform' },
        ],
      },
    ],
  },
  customers: {
    title: 'Customers',
    sections: [
      {
        heading: 'Customers',
        items: [
          { label: 'All Success Stories', description: 'Hear from 85+ companies', href: '/customers' },
          { label: 'By Industry', description: 'Explore by sector', href: '/customers/industries' },
          { label: 'Customer Community', description: 'Join the global community', href: '/customers/community' },
        ],
      },
    ],
  },
  resources: {
    title: 'Resources',
    sections: [
      {
        heading: 'Learn',
        items: [
          { label: 'Insights & Reports', description: 'Research and analyst reports', href: '/insights' },
          { label: 'Blog', description: 'Latest thinking from MetaxuOne', href: '/blog' },
          { label: 'Webinars & Events', description: 'On-demand and live sessions', href: '/events' },
          { label: 'Documentation', description: 'Product docs and APIs', href: '/docs' },
        ],
      },
      {
        heading: 'Portals',
        items: [
          { label: 'Partner Portal', description: 'Training, certification, deal registration', href: '/partner-portal' },
          { label: 'Employee Portal', description: 'Onboarding, learning, internal tools', href: '/employee-portal' },
        ],
      },
    ],
  },
  company: {
    title: 'Company',
    sections: [
      {
        heading: 'About',
        items: [
          { label: 'About MetaxuOne', description: 'Our mission and story', href: '/about' },
          { label: 'Leadership', description: 'Meet the executive team', href: '/about/leadership' },
          { label: 'Newsroom', description: 'Press releases and news', href: '/news' },
          { label: 'Careers', description: 'Join our team', href: '/careers' },
        ],
      },
    ],
  },
};

export const solutions = [
  {
    id: 'ai',
    tag: 'Initiative',
    title: 'Artificial Intelligence (AI)',
    tagline: 'AI that knows how your business flows.',
    bullets: [
      { heading: 'Give AI context', text: 'Empower Enterprise AI with the operational clarity it needs to succeed.' },
      { heading: 'Deploy AI strategically', text: 'Identify high-impact AI use cases and measure RoAI.' },
      { heading: 'Integrate AI into operations', text: 'Orchestrate people, agents, and existing technologies to drive outcomes.' },
    ],
  },
  {
    id: 'supply-chain',
    tag: 'Function',
    title: 'Supply Chain',
    tagline: 'AI-powered supply chain transformation.',
    bullets: [
      { heading: 'Improve service levels', text: 'Improve on-time in-full delivery, reduce stockouts, and improve supplier reliability.' },
      { heading: 'Optimize working capital', text: 'Accelerate slow-moving inventory, and reduce and reallocate excess.' },
      { heading: 'Contain costs', text: 'Optimize load consolidation, and reduce operating costs and spot purchasing.' },
    ],
  },
  {
    id: 'it',
    tag: 'Function',
    title: 'Enterprise IT Modernization',
    tagline: 'When processes work, IT works.',
    bullets: [
      { heading: 'Set modernization strategy', text: 'Align, plan, and execute your modernization strategy using objective information.' },
      { heading: 'Make Enterprise AI work', text: 'Power Enterprise AI with real-time operational context.' },
      { heading: 'Migrate with confidence', text: 'Separate true differentiation from technical debt, reducing migration risk.' },
    ],
  },
  {
    id: 'finance',
    tag: 'Function',
    title: 'Finance and Shared Services',
    tagline: 'Take action with less risk, more reward.',
    bullets: [
      { heading: 'Improve cash flow', text: 'Optimize payments and accelerate collections.' },
      { heading: 'Reduce costs', text: 'Prevent duplicate payments and excess spend.' },
      { heading: 'Increase productivity', text: 'Automate actions and improve cycle times.' },
    ],
  },
  {
    id: 'process',
    tag: 'Initiative',
    title: 'Process Excellence',
    tagline: 'When processes work, everything works.',
    bullets: [
      { heading: 'Analyze', text: 'Understand how your processes truly run. Identify the most impactful opportunities.' },
      { heading: 'Design', text: 'Redesign operations to integrate Enterprise AI. Define workflows and guardrails.' },
      { heading: 'Operate', text: 'Continuously monitor process performance, adherence, and agent activity.' },
    ],
  },
];

export const services = [
  {
    id: 'implementation',
    icon: 'Rocket',
    title: 'Implementation',
    description: 'End-to-end deployment of the MetaxuOne platform from data integration to first value.',
    highlights: ['Data connectivity', 'Process model setup', 'KPI alignment', 'Go-live enablement'],
  },
  {
    id: 'advisory',
    icon: 'Compass',
    title: 'Advisory & Strategy',
    description: 'Strategic guidance to define your Process Intelligence and Enterprise AI roadmap.',
    highlights: ['Maturity assessment', 'Use case prioritization', 'Operating model design', 'Executive workshops'],
  },
  {
    id: 'value',
    icon: 'TrendingUp',
    title: 'Value Engineering',
    description: 'A proven methodology to identify, capture, and scale measurable business value.',
    highlights: ['Opportunity sizing', 'Business case design', 'Benefit realization', 'Value tracking'],
  },
  {
    id: 'managed',
    icon: 'Settings2',
    title: 'Managed Services',
    description: 'Run, monitor, and continuously improve your MetaxuOne deployment with our experts.',
    highlights: ['24/7 monitoring', 'Process tuning', 'Quarterly reviews', 'Scaling playbooks'],
  },
  {
    id: 'training',
    icon: 'GraduationCap',
    title: 'Training & Enablement',
    description: 'Build internal expertise with certifications, learning paths, and hands-on workshops.',
    highlights: ['Role-based academy', 'Certifications', 'Live labs', 'Coaching'],
  },
  {
    id: 'support',
    icon: 'LifeBuoy',
    title: 'Premium Support',
    description: 'Round-the-clock, priority support with named technical account managers.',
    highlights: ['24/7 response', 'TAM included', 'Health checks', 'Priority escalation'],
  },
];

export const stories = [
  {
    company: 'Northwind Industries',
    title: 'Full transparency into inventory levels',
    excerpt: 'Northwind Industries uses MetaxuOne to gain transparency into inventory and AI-enhanced recommendations.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80',
  },
  {
    company: 'Vantage Energy',
    title: 'Transforming how work gets done',
    excerpt: 'Vantage Energy is transforming work with MetaxuOne Process Intelligence and modern AI.',
    image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&q=80',
  },
  {
    company: 'Meridian Bank',
    title: 'Transforming CIB Operations',
    excerpt: 'Meridian Bank uses MetaxuOne PI to enable transparency, AI, and automation across operations.',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80',
  },
  {
    company: 'Lumen Foods',
    title: 'Faster, stronger, better',
    excerpt: 'Lumen Foods uses MetaxuOne Process Mining to unlock millions of dollars across the company.',
    image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=800&q=80',
  },
];

export const insights = [
  {
    badge: '2026 Industry Analyst Report',
    title: 'MetaxuOne named a Leader in the 2026 Industry Analyst Report for Process Intelligence Platforms',
    cta: 'Download now',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
  },
  {
    badge: 'Announcement',
    title: 'MetaxuOne Launches the Context Model to Eliminate Enterprise AI\u2019s Operational Blind Spots',
    cta: 'Read more',
    image: 'https://images.unsplash.com/photo-1535378917042-10a22c95931a?w=800&q=80',
  },
  {
    badge: 'Event',
    title: 'MetaxuOne:NEXT \u2014 discover new AI capabilities across the platform',
    cta: 'Watch now',
    image: 'https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=800&q=80',
  },
];

export const customerLogos = [];

export const stats = [
  { value: '85+', label: 'Global customer engagement' },
  { value: '$10B+', label: 'Value identified' },
  { value: '66%', label: 'Increase in AI-powered automation' },
  { value: '24', label: 'Cities on the Process Intelligence tour' },
];
